import { GroupIdsByName, Orientations, mensSizes, boysSizes } from '@/enums/products'
import { MembershipTypes } from './member'
import { CountryCodes } from '@/enums/general'

export const idPrefixes = Object.freeze({
  prospect: '/api/prospects/',
  paymentServiceProviderSetting: '/api/payment_service_provider_settings/',
  product_group: '/api/product_groups/',
  size: '/api/sizes/',
  address: '/api/addresses/',
  country: '/api/countries/code/',
  orderBundle: '/api/order_bundles/',
  orders: '/api/orders/',
  design: '/api/designs/',
  member: '/api/members/',
  user: '/api/users/',
  membershipType: '/api/membership_types/reference/',
  productGroupSizes: '/api/product_group_sizes/reference/',
  designReference: '/api/designs/reference/'
})

export const defaultState = Object.freeze({
  form: {
    [Orientations.womenbralette]: {
      size: {
        reference: null,
        label: null
      },
      design: {
        name: null,
        slug: null
      }
    },
    [Orientations.womenhipster]: {
      size: {
        reference: null,
        label: null
      },
      design: {
        name: null,
        slug: null
      }
    },
    prospectId: null,
    membershipType: '',
    size: {
      reference: null,
      label: null
    },
    design: {
      name: null,
      slug: null
    },
    fixedDesign: {
      name: null,
      slug: null
    },
    secondaryFixedDesign: {
      name: null,
      slug: null
    },
    freeMembershipType: '',
    freeSize: {
      reference: null,
      label: null
    },
    freeDesign: {
      name: null,
      slug: null
    },
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    promotionCode: '',
    promotionOffer: '',
    consent: false,
    optIn: false,
    paymentId: '',
    address: {
      streetType: '',
      street: '',
      floor: '',
      houseNumber: null,
      annex: '',
      houseNumberAddition: '',
      building: '',
      postalCode: '',
      city: '',
      region: '',
      loqateAddressId: null
    }
  },
  addressConfirmed: false,
  isSizeModalOpen: false,
  currentStep: 0,
  previousRoute: '',
  previousRouteParams: {},
  nextRoute: ''
})

export const QueryParams = Object.freeze({
  orientation: 'orientation',
  previousroute: 'previousroute',
  sizeid: 'sizeid',
  sizelabel: 'sizelabel'
})

export const SoldOutBoxerOrientationsSize = Object.freeze([
  ...mensSizes.map((size) => ({
    orientation: GroupIdsByName[Orientations.menoriginals],
    sizeLabel: size.label
  })),
  ...mensSizes.map((size) => ({
    orientation: GroupIdsByName[Orientations.menone],
    sizeLabel: size.label
  })),
  ...boysSizes.map((size) => ({
    orientation: GroupIdsByName[Orientations.boysoriginals],
    sizeLabel: size.label
  }))
])

export const WomenSignupMembershipTypes = Object.freeze([MembershipTypes.women])

export const PromoCodesByVendor = Object.freeze({
  Sovendus: Object.values(CountryCodes).map((countryCode) => `OTAFREE-${countryCode.toUpperCase()}`)
})

export const OnePagerTypes = Object.freeze({
  minimal: 'minimal',
  withDesignChoice: 'withDesignChoice',
  womenMinimal: 'womenMinimal',
  womenWithDesignChoice: 'womenWithDesignChoice'
})
